import SabalPriceSheetsMappingsActivity from './PriceSheetsMappingsActivity';

const SabalPriceSheetsMappingsCreated = ({ event }: { event: any }) => {
  return <SabalPriceSheetsMappingsActivity event={event} label="created" />;
};

export default SabalPriceSheetsMappingsCreated;
